import React from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';

/**
 * Reusable editable row input component - Odoo style
 * Used for sections, notes, and catalog items in quotations
 * 
 * @param {string} value - Current input value
 * @param {function} onChange - Callback when value changes
 * @param {function} onDelete - Callback when delete is clicked
 * @param {string} placeholder - Placeholder text for empty input
 * @param {boolean} bold - Whether to display text in bold (for sections)
 * @param {object} sx - Additional styles to apply
 */
const EditableRowInput = ({
  value,
  onChange,
  onDelete,
  placeholder = 'Enter a description',
  bold = false,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        borderBottom: '1px solid #e0e0e0',
        backgroundColor: 'transparent',
        ...sx,
      }}
    >
      <TextField
        fullWidth
        variant="standard"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        InputProps={{
          disableUnderline: true,
          sx: {
            fontSize: '14px',
            fontWeight: bold ? 600 : 400,
            color: value ? '#333' : '#9e9e9e',
            py: 1,
            px: 1,
            '& input': {
              padding: 0,
            },
            '& input::placeholder': {
              color: '#9e9e9e',
              opacity: 1,
              fontStyle: 'italic',
            },
          },
        }}
      />
      <IconButton
        size="small"
        onClick={onDelete}
        sx={{
          mr: 0.5,
          color: '#9e9e9e',
          '&:hover': {
            color: '#666',
            backgroundColor: 'transparent',
          },
        }}
      >
        <Delete sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};

export default EditableRowInput;
